
// Select the target node
var targetNode = document.querySelector('.productView-price');

// Options for the observer (which mutations to observe)
var config = { attributes: true, childList: true, subtree: true };
var money =  document.querySelector('.sMoney'); 
// Callback function to execute when mutations are observed
var callback = function(mutationsList, observer) {
    // Handle the changes to the span's value here
    // For example, you can retrieve the updated value and perform necessary actions
    console.log('mutation observed!');
    var originalPrice = targetNode.querySelector('.price__last .price-item').textContent.trim();
    var originalPriceNumber = parseFloat(originalPrice.replace('$', ''));
    var quarterPrice = originalPriceNumber / 4;
    var formattedQuarterPrice = '$' + quarterPrice.toFixed(2);
    console.log('New formatted quarter price: ' + formattedQuarterPrice);
    if(money){
        money.textContent= formattedQuarterPrice;
    }
    
};

// Create a new observer
var observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);